import { differenceInDays, differenceInYears } from 'date-fns'
import moment from 'moment'

const MAX_AGE = 110
const MIN_AGE = 18
const PRE_POPULATION_THRESHOLD = 30

export const MESSAGES = {
  invalid: 'Please enter a valid birthday.',
  maxAge: 'Are you really that old? Contact support@acorns.com.',
  minAge: 'You must be 18 or older to open an Acorns account.',
}

export const validateDob = (
  value: string,
  current: number,
  dateFormat = 'MM/DD/YYYY',
): true | string => {
  let message
  const momentDOB = moment(value, dateFormat, true)

  if (!momentDOB.isValid()) {
    return MESSAGES.invalid
  }

  const parsed = momentDOB.toDate()

  const age = differenceInYears(current, parsed)

  if (parsed && age < MIN_AGE) {
    message = MESSAGES.minAge
  } else if (parsed && age > MAX_AGE) {
    message = MESSAGES.maxAge
  }

  if (message) {
    return message
  }

  return true
}

export const validateBeneficiaryDob = (value: string, current: number): true | string => {
  let message

  const parsed = Date.parse(value)

  if (!parsed) {
    message = MESSAGES.invalid
  }

  const age = current - parsed

  if (parsed && age < 0) {
    message = MESSAGES.invalid
  }

  if (message) {
    return message
  }

  return true
}

export const canPrePopulate = (sinceDate: string) => {
  if (!sinceDate) {
    return false
  }

  try {
    const daysSinceCreated = differenceInDays(new Date(), new Date(sinceDate))
    return daysSinceCreated < PRE_POPULATION_THRESHOLD
  } catch {
    return false
  }
}
